<template>
  <div class="cart-main-products-container">
    <!-- OLDTODO: Wrap the warnings in another component -->
    <template v-if="!isOnCheckoutPage">
      <!-- Express checkout address error-->
      <div class="alert alert-danger error-message" role="alert" aria-atomic="true" style="display: block"
        v-if="addressError">
        <p class="error-message-text"><span>{{ addressError }}</span></p>
      </div>
      <!-- Express checkout address error-->

      <!-- ProductsOutOfStock -->
      <div id="out-of-stock-warning" v-if="areProductsOutOfStock" class="out-of-stock-warning">
        <div class="info-icon">
          <svg class="info-icon svg-icon">
            <use :href="`${svgPath}#info`" />
          </svg>
        </div>
        <div class="text">
          <span v-html="$t('label.warning.out.of.stock')"></span>
        </div>
      </div>
      <!-- ProductsOutOfStock -->

      <!-- ProductsMissingPrice -->
      <div v-if="areMissingPriceProducts" class="out-of-stock-warning">
        <div class="info-icon">
          <svg class="info-icon svg-icon">
            <use :href="`${svgPath}#info`" />
          </svg>
        </div>
        <div class="text">
          <span v-html="$t('error.items.notavailable')"></span>
        </div>
      </div>
      <!-- ProductsMissingPrice -->

      <div class="alert alert-danger error-message" role="alert" aria-atomic="true" style="display: block"
        v-if="cart.isGratisError || cart.isGratisMix">
        <p class="error-message-text">
          <span v-if="cart.isGratisError && !cart.isGratisMix" v-html="$t('error.gratis.not.eligible')"></span>
          <span v-if="cart.isGratisMix" v-html="$t('error.gratis.mix.not.eligible')"></span>
        </p>
      </div>


      <!-- ProductsMaxQuantityExceeded -->
      <div id="max-quantity-warning" v-if="areProductsWithMaxQuantityExceed" class="max-quantity-warning">
        <div class="info-icon">
          <svg class="info-icon svg-icon">
            <use :href="`${svgPath}#info`" />
          </svg>
        </div>
        <div class="text">
          <span v-html="$t('label.warning.max.quantity.exceeded')"></span>
        </div>
      </div>
      <!--  ProductsMaxQuantityExceeded -->

      <!-- ProductsHazardous -->
      <div v-if="areProductsHazardous" class="hazardous-products-warning">
        <div class="hazardous-alert-icon-wrapper">
          <svg class="hazardous-alert-icon">
            <use :href="`${svgPath}#hazardous-alert`" />
          </svg>
        </div>

        <div class="text">
          <span v-html="$t('label.warning.hazardous.products')"></span>
        </div>
      </div>
      <!-- ProductsHazardous -->

      <!-- ProductsHaveReplinishment -->
      <!-- <div
      v-if="isSOREnabled && !isCustomerAuthenticated"
      class="replenishment-warning"
    >
      <div class="info-icon">
        <svg class="info-icon">
          <use :href="`${svgPath}#info`" />
        </svg>
      </div>
      <div
        class="text"
        v-html="$t('label.warning.replenishment', ['font-weight-bold'])"
      ></div>
    </div> -->
      <!-- ProductsHaveReplinishment -->
    </template>
    <!-- OLDTODO: Wrap the warnings in another component -->


    <div class="products-header">
      <h2 :class="!isOnCheckoutPage ? 'my-bag' : 'h3 mb-0'">
        <span v-html="$t(!isOnCheckoutPage ? 'title.your.shopping.cart' : 'title.checkout.inyourbag')"></span>
      </h2>
      <span v-html="
        $t(
          cart.numItems === 1
            ? 'label.number.item.in.cart'
            : 'label.number.items.in.cart',
          [cart.numItems]
        )
      " :class="!isOnCheckoutPage ? 'number-of-items font-weight-light' : 's-h-count'"
      :role="!isOnCheckoutPage ? 'alert' : null" :aria-live="!isOnCheckoutPage? 'assertive' : null">
      </span>
    </div>

    <div class="pli-wrapper" v-for="(product, index) in cart.items" :key="'pli' + product.productName + index">
      <ProductLineItem v-if="
        (!product.isSample &&
          !product.bonusProductLineItemUUID &&
          !product.engravedProductID &&
          !product.isInGiftBox && !isGiftDummyItem(product)) ||
        (product.bonusProductLineItemUUID && isInjectedBonusProduct(product)) || hasMiniCartConfiguration(product)
      " :product="product" />
      <ProductEngraving v-if="product.engravedProductID && product.engravedText" :product="product"
        :key="'pli-engraving' + product.engravedProductID + index" />
      <template v-if="product.isDummyProduct">
        <ProductLineItem v-for="(box, index) in cart.boxContents.boxContents"
          :key="product.productName + box.byosBoxName + index" :product="product" :box="box" />
      </template>
    </div>
    <!-- ! <GiftBox > -->
      <template v-if="isOnCheckoutPage">
        <div
          :class="`product-line-item gift-line-item vue-product-line-item ${(giftWrappingMessageChecked || giftWrappingMessage || giftWrappingVideo) ? '' : 'd-none'}`">
          <div class="item-image text-center">
            <img class="img-fluid product-image" :src="FRESH_giftWrappingImage" alt="Gift Box" />
          </div>
          <div class="item-description">
            <span v-html="$t('check.gift.header.wrapping')"></span>
            <span :class="`item-video-message ${giftWrappingVideo ? '' : 'd-none'}`"
              v-html="$t('product.summary.gift.video.message.header')"></span>
            <span :class="`item-gift-message body-alt text-break ${giftWrappingMessage.length > 0 ? '' : 'd-none'}`"
              data-cs-mask>
              {{ $t('heading.gift.message') }}
              <span>{{ giftWrappingMessage ? decodeURIComponent(giftWrappingMessage) : '' }}</span>
            </span>
          </div>
        </div>
      </template>
      <!-- ! <GiftBox > -->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import ProductLineItem from "./ProductLineItem";
import ProductEngraving from "./ProductEngraving";
import { EventBus } from "@/scripts/event-bus.js";
import { useRoute } from 'vue-router'
import { mapGetters as vue3_mapGetters } from "@/store/helper/vuex";
import { svgIcon } from "@/components/helper/util"
import { computed } from "vue";

export default {
  name: "ProductsContainer",
  components: {
    ProductLineItem,
    ProductEngraving,
  },
  setup() {
    const { checkout, vueVariables, giftWrappingMessage, giftWrappingVideo, giftWrappingMessageChecked } = vue3_mapGetters();
    const pdict = checkout;

    const { paths } = window.vue;

    const route = useRoute();

    const isOnCheckoutPage = computed(() => { return route ? route.path.includes(paths['/checkout']) : false });
    // const isOnCartPage = route ? route.path === paths['/'] : false;

    return {
      isOnCheckoutPage,
      pdict,
      svgIcon,
      giftWrappingMessage,
      giftWrappingVideo,
      giftWrappingMessageChecked,
      vueVariables
      // isOnCartPage,
    };
  },
  data() {
    return {
      giftBoxItemID: window.vue.customPreferences.giftBoxItemID,
      isMiniCart: window.vueCurrentActiveStates['mini-cart'],
      addressError: this.vueVariables.addressError,
      FRESH_giftWrappingImage: window.vue.customPreferences.FRESH_giftWrappingImage
    };
  },
  methods: {
    hasMiniCartConfiguration(product) {
      return (this.isMiniCart || this.isOnCheckoutPage) && (product.isSample || product.isBonusProductLineItem) && (!product.isInGiftBox && !this.isGiftDummyItem(product));
    },
    isGiftDummyItem(product) {
      return product.id === this.giftBoxItemID;
    },
    isInjectedBonusProduct(product) {
      if (this.cart.BonusLineItemContainer.length == 0) return true;

      let injectedBonusProduct =
        this.cart.BonusLineItemContainer[0].bonusLinesInCart.find(
          (pid) => pid == product.id
        );
      return injectedBonusProduct ? false : true;
    },
    ...mapActions({
      removeProduct: "removeProduct",
    }),

  },

  computed: {
    isCustomerAuthenticated: function () {
      return this.vueVariables.isCustomerAuthenticated;
    },
    ...mapState(["svgPath"]),

    isSOREnabled: function () {
      return this.cart.items.some((item) => {
        return item.SorPeriodicity && item.SorPeriodicity !== undefined && item.SorPeriodicity !== null
      });
    },

    areProductsOutOfStock: function () {
      return this.cart.items.some(
        (item) => item.available == false
      );
    },

    areMissingPriceProducts: function () {
      return this.cart.totals.subTotal === '-';
    },

    areProductsWithMaxQuantityExceed: function () {
      return this.cart.items.some(
        (item) => item.available && item.quantity > item.quantityOptions.maxOrderQuantity
      );
    },

    areProductsHazardous: function () {
      return this.cart.hasHazardousMaterialProducts === true;
    },

    isByosPresent: function () {
      return (
        this.cart.boxContents &&
        this.cart.boxContents.byosPidsQtys &&
        this.cart.boxContents.byosPidsQtys.pidQtys
      );
    },

    ...mapGetters({
      cart: "cart"
    }),
  },
  created() {},
  mounted() {},
};
</script>

<style >

</style>
